import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../baseQuery";
import { TRIMFABRIC_API } from "../../Api";

const BASE_URL = process.env.REACT_APP_SERVER_URL;

const trimFabricMasterApi = createApi({
  reducerPath: "trimFabricMaster",
  baseQuery,
  tagTypes: ["trimFabric"],
  endpoints: (builder) => ({
    gettrimFabric: builder.query({
      query: ({ params, searchParams }) => {
        if (searchParams) {
          return {
            url: TRIMFABRIC_API + "/search/" + searchParams,
            method: "GET",
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
            params
          };
        }
        return {
          url: TRIMFABRIC_API,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
          params
        };
      },
      providesTags: ["trimFabric"],
    }),
    gettrimFabricById: builder.query({
      query: (id) => {
        return {
          url: `${TRIMFABRIC_API}/${id}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      providesTags: ["trimFabric"],
    }),
    addtrimFabric: builder.mutation({
      query: (payload) => ({
        url: TRIMFABRIC_API,
        method: "POST",
        body: payload,
        headers: {
          "Content-type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["trimFabric"],
    }),
    updatetrimFabric: builder.mutation({
      query: (payload) => {
        const { id, ...body } = payload;
        return {
          url: `${TRIMFABRIC_API}/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: ["trimFabric"],
    }),
    deletetrimFabric: builder.mutation({
      query: (id) => ({
        url: `${TRIMFABRIC_API}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["trimFabric"],
    }),
  }),
});

export const {
  useGettrimFabricQuery,
  useGettrimFabricByIdQuery,
  useAddtrimFabricMutation,
  useUpdatetrimFabricMutation,
  useDeletetrimFabricMutation,
} = trimFabricMasterApi;

export default trimFabricMasterApi;
